export class Helper {
    // returns bit length of the integer x
static nbits(x: any): any {
    var r = 1, t;
    if ((t = x >>> 16) != 0) { x = t; r += 16; }
    if ((t = x >> 8) != 0) { x = t; r += 8; }
    if ((t = x >> 4) != 0) { x = t; r += 4; }
    if ((t = x >> 2) != 0) { x = t; r += 2; }
    if ((t = x >> 1) != 0) { x = t; r += 1; }
    return r;
}


    static BI_FP: number;
    static BI_RM: string;
    static BI_RC: any[];

    public static int2char(n: any) { return Helper.BI_RM.charAt(n); }

    public static intAt(s: any, i: any) {
        var c = Helper.BI_RC[s.charCodeAt(i)];
        return (c == null) ? -1 : c;
    }
}